/* eslint-disable @typescript-eslint/no-explicit-any */
import { Delete, Get, Patch, Post } from "./apiHelper";
import { ApiResponse } from "../interfaces/Api";
import { IShift } from "../interfaces/ShiftInterface";

const shiftRoot = "/api/shifts";

// get shifts
export async function getShifts({
  resourceCentreId
}: {
  resourceCentreId: number;
}): Promise<ApiResponse<Array<IShift>>> {
  const searchParams = new URLSearchParams();
  searchParams.append("resourceCentreId", resourceCentreId.toString());

  const response = await Get(`${shiftRoot}?${searchParams.toString()}`, true);
  return response.data as ApiResponse<Array<IShift>>;
}

// post shift
export async function postShift(data: Partial<IShift>): Promise<ApiResponse<IShift>> {
  const response = await Post(`${shiftRoot}`, data as any, true);
  return response.data as ApiResponse<IShift>;
}

// patch shift
export async function patchShift({
  id,
  data
}: {
  id: number | string;
  data: Partial<IShift>;
}): Promise<ApiResponse<IShift>> {
  const response = await Patch(`${shiftRoot}/${id}`, data as any, true);
  return response.data as ApiResponse<IShift>;
}

// delete shift
export async function deleteShift(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${shiftRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
